export default {
  en: {
    tools: {
      indexpage: {
        metatitle: 'Tools',
        metadesc: 'Tools to help pilots and student pilots to learn and practice but also to assist them in regular flight operations.',
        desc: 'We provide some tools to help pilots and student pilots to learn and practice but also to assist them in regular flight operations. The tools are available for free and can be used without any registration.',
      },
      aerodrome: {
        cardtitle: 'Aerodromes',
        carddescription: 'Find any ICAO aerodrome in the world.',
        desc: 'This tool allows you to search for aerodromes by ICAO code or name. You can also search for aerodromes by their location.',
        meta: {
          title: 'Aerodrome search',
          desc: 'Search for aerodromes by ICAO code or name and get their runways, frequencies and more.',
        },
        searchlabel: 'Aerodrome (ICAO, IATA, name or location)',
        min: '3 characters minimum',
      },
      frequency: {
        cardtitle: 'Frequencies',
        carddescription: 'Find the correct frequencies.',
        desc: 'Search for frequencies by aerodromes, VORs, NDBs and other radio stations by ICAO code, IATA code, name or location.',
        meta: {
          title: 'Frequency search',
          desc: 'Search for frequencies by aerodromes, VORs, NDBs and other radio stations by ICAO code, IATA code, name or location.',
        },
        searchlabel: 'Frequencies (118.000 MHz - 136.975 MHz)',
        min: '3 characters minimum',
      },
      flightschool: {
        cardtitle: 'Flight Schools',
        carddescription: 'Find flight schools around the world.',
        desc: 'This tool allows you to search for flight schools by name or location.',
        meta: {
          title: 'Flight school search',
          desc: 'Search for flight schools by name or location and get their contact information and more.',
        },
        map_pois: 'Currently shown facilities on map: {count}',
        table: {
          homeairport: 'Home airport',
          website: 'Website',
          email: 'Email',
          phone: 'Phone',
          coordinates: 'Coordinates',
          showbutton: 'Show on map',
        },
        moredetailsbutton: 'Show more details',
      }
    }
  },
  de: {
    tools: {
      indexpage: {
        metatitle: 'Werkzeuge',
        metadesc: 'Werkzeuge, die Piloten und Schülerpiloten helfen, zu lernen und zu üben, aber auch um sie bei regulären Flugbetrieben zu unterstützen.',
        desc: 'Wir stellen einige Werkzeuge zur Verfügung, die Piloten und Schülerpiloten helfen, zu lernen und zu üben, aber auch um sie bei regulären Flugbetrieben zu unterstützen. Die Werkzeuge sind kostenlos verfügbar und können ohne Registrierung genutzt werden.',
      },
      aerodrome: {
        cardtitle: 'Flughäfen',
        carddescription: 'Finde jeden ICAO-Flughafen der Welt.',
        desc: 'Dieses Tool ermöglicht es dir, nach Flughäfen anhand des ICAO-Codes oder Namens zu suchen. Du kannst auch nach Flughäfen anhand ihres Standorts suchen.',
        meta: {
          title: 'Flughafensuche',
          desc: 'Suche nach Flughäfen anhand des ICAO-Codes oder Namens und erhalte Informationen zu Start- und Landebahnen, Frequenzen und mehr.',
        },
        searchlabel: 'Flughafen (ICAO, IATA, Name oder Standort)',
        min: 'Mindestens 3 Zeichen',
      },
      frequency: {
        cardtitle: 'Frequenzen',
        carddescription: 'Finde die richtigen Frequenzen.',
        desc: 'Suche nach Frequenzen von Flughäfen, VORs, NDBs und anderen Funkstationen anhand des ICAO-Codes, IATA-Codes, Namens oder Standorts.',
        meta: {
          title: 'Frequenzensuche',
          desc: 'Suche nach Frequenzen von Flughäfen, VORs, NDBs und anderen Funkstationen anhand des ICAO-Codes, IATA-Codes, Names oder Standorts.',
        },
        searchlabel: 'Frequenzen (118.000 MHz - 136.975 MHz)',
        min: 'Mindestens 3 Zeichen',
      },
      flightschool: {
        cardtitle: 'Flugschulen',
        carddescription: 'Finde Flugschulen auf der ganzen Welt.',
        desc: 'Dieses Tool ermöglicht es dir, nach Flugschulen anhand des Namens oder Standorts zu suchen.',
        meta: {
          title: 'Flugschulensuche',
          desc: 'Suche nach Flugschulen anhand des Namens oder Standorts und erhalte deren Kontaktinformationen und mehr.',
        },
        map_pois: 'Derzeit angezeigte Einrichtungen auf der Karte: {count}',
        table: {
          homeairport: 'Heimatflughafen',
          website: 'Webseite',
          email: 'E-Mail',
          phone: 'Telefon',
          coordinates: 'Koordinaten',
          showbutton: 'Auf Karte anzeigen',
        },
        moredetailsbutton: 'Mehr Details anzeigen',
      }
    }
  },
  es: {
    tools: {
      indexpage: {
        metatitle: 'Herramientas',
        metadesc: 'Herramientas para ayudar a pilotos y estudiantes de piloto a aprender y practicar, pero también para asistirlos en operaciones de vuelo regulares.',
        desc: 'Proporcionamos algunas herramientas para ayudar a pilotos y estudiantes de piloto a aprender y practicar, pero también para asistirlos en operaciones de vuelo regulares. Las herramientas están disponibles de forma gratuita y se pueden usar sin ningún registro.',
      },
      aerodrome: {
        cardtitle: 'Aeródromos',
        carddescription: 'Encuentra cualquier aeródromo ICAO en el mundo.',
        desc: 'Esta herramienta te permite buscar aeródromos por código ICAO o nombre. También puedes buscar aeródromos por su ubicación.',
        meta: {
          title: 'Búsqueda de aeródromos',
          desc: 'Busca aeródromos por código ICAO o nombre y obtén información sobre sus pistas, frecuencias y más.',
        },
        searchlabel: 'Aeródromo (ICAO, IATA, nombre o ubicación)',
        min: 'Mínimo 3 caracteres',
      },
      frequency: {
        cardtitle: 'Frecuencias',
        carddescription: 'Encuentra las frecuencias correctas.',
        desc: 'Busca frecuencias por aeródromos, VORs, NDBs y otras estaciones de radio por código ICAO, código IATA, nombre o ubicación.',
        meta: {
          title: 'Búsqueda de frecuencias',
          desc: 'Busca frecuencias por aeródromos, VORs, NDBs y otras estaciones de radio por código ICAO, código IATA, nombre o ubicación.',
        },
        searchlabel: 'Frecuencias (118.000 MHz - 136.975 MHz)',
        min: 'Mínimo 3 caracteres',
      },
      flightschool: {
        cardtitle: 'Escuelas de Vuelo',
        carddescription: 'Encuentra escuelas de vuelo alrededor del mundo.',
        desc: 'Esta herramienta te permite buscar escuelas de vuelo por nombre o ubicación.',
        meta: {
          title: 'Búsqueda de escuelas de vuelo',
          desc: 'Busca escuelas de vuelo por nombre o ubicación y obtén su información de contacto y más.',
        },
        map_pois: 'Instalaciones actualmente mostradas en el mapa: {count}',
        table: {
          homeairport: 'Aeropuerto base',
          website: 'Sitio web',
          email: 'Correo electrónico',
          phone: 'Teléfono',
          coordinates: 'Coordenadas',
          showbutton: 'Mostrar en el mapa',
        },
        moredetailsbutton: 'Mostrar más detalles',
      }
    }
  },
  uk: {
    tools: {
      indexpage: {
        metatitle: 'Інструменти',
        metadesc: 'Інструменти, які допомагають пілотам та студентам-пілотам навчатися та практикуватися, а також допомагають їм у звичайних польотних операціях.',
        desc: 'Ми надаємо деякі інструменти, які допомагають пілотам та студентам-пілотам навчатися та практикуватися, а також допомагають їм у звичайних польотних операціях. Інструменти доступні безкоштовно і можуть використовуватися без реєстрації.',
      },
      aerodrome: {
        cardtitle: 'Аеродроми',
        carddescription: 'Знайдіть будь-який аеродром ICAO у світі.',
        desc: 'Цей інструмент дозволяє шукати аеродроми за кодом ICAO або назвою. Ви також можете шукати аеродроми за їхнім розташуванням.',
        meta: {
          title: 'Пошук аеродромів',
          desc: 'Шукайте аеродроми за кодом ICAO або назвою та отримуйте інформацію про їхні злітно-посадкові смуги, частоти та інше.',
        },
        searchlabel: 'Аеродром (ICAO, IATA, назва або розташування)',
        min: 'Мінімум 3 символи',
      },
      frequency: {
        cardtitle: 'Частоти',
        carddescription: 'Знайдіть правильні частоти.',
        desc: 'Шукайте частоти аеродромів, VOR, NDB та інших радіостанцій за кодом ICAO, кодом IATA, назвою або розташуванням.',
        meta: {
          title: 'Пошук частот',
          desc: 'Шукайте частоти аеродромів, VOR, NDB та інших радіостанцій за кодом ICAO, кодом IATA, назвою або розташуванням.',
        },
        searchlabel: 'Частоти (118.000 МГц - 136.975 МГц)',
        min: 'Мінімум 3 символи',
      },
      flightschool: {
        cardtitle: 'Льотні школи',
        carddescription: 'Знайдіть льотні школи по всьому світу.',
        desc: 'Цей інструмент дозволяє шукати льотні школи за назвою або розташуванням.',
        meta: {
          title: 'Пошук льотних шкіл',
          desc: 'Шукайте льотні школи за назвою або розташуванням та отримуйте їх контактну інформацію та інше.',
        },
        map_pois: 'Наразі на карті показано заклади: {count}',
        table: {
          homeairport: 'Домашній аеропорт',
          website: 'Вебсайт',
          email: 'Електронна пошта',
          phone: 'Телефон',
          coordinates: 'Координати',
          showbutton: 'Показати на карті',
        },
        moredetailsbutton: 'Показати більше деталей',
      }
    }
  }
}
